import React, { useCallback, useEffect, useRef, useState, useContext } from 'react';
import { GoogleMap } from '@react-google-maps/api';
import { v4 } from "uuid";
import style from "./Tab2Content.module.scss";
import AppConfig from '../../AppConfig';
import styled from "styled-components";
import AreaItem from "./AreaItem";
import TabList from '../../comm/global/components/TabList';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { convertImagePathToImageBitmap, createImageWithLabel, expandBounds, stepZoom, wait, generateRandomCoordinates, fixWhiteLine } from '../../comm/comm';
import OverlaySky from './OverlaySky';
import OverlayAlbum from './OverlayAlbum';
import * as YStyled from "../../Styleds";
import html2canvas from 'html2canvas';
import BottomUi from './BottomUi';
import apiManager from '../../ApiManager';
import { GameContext } from "../../GameContext";
const groupList = [
    { label: "百岳", name: "big", iconSelect: "./assets/bigYamaFocus.png", icon: "./assets/bigYamaNormal.png" },
    { label: "小百岳", name: "small", iconSelect: "./assets/smallYamaFocus.png", icon: "./assets/smallYamaNormal.png" },
    { label: "保護區", name: "protect", iconSelect: "./assets/potFocus.png", icon: "./assets/potNormal.png" },
];

function Tab2Content({ addModalType, setModalType, screenArg, type = "user", friendVo, onExitCb }) {
    const pageRef = useRef();
    const { rewilding, userData ,achievementFriend, set_achievementFriend} = useContext(GameContext);
    const [isOpen, setIsOpen] = useState(false);
    const [groupSelectId, set_groupSelectId] = useState(null);
    const [mapStyles, setMapStyles] = useState(AppConfig.initialMapStyles);
    const [map, setMap] = useState(null);
    const [myRewild, set_myRewild] = useState([]);
    const [hasPolaroidsEvents, set_hasPolaroidsEvents] = useState([]);
    //連線開關
    const [polylineEnable, set_polylineEnable] = useState(false);
    //是否在zoom內
    const [polylineOnZoom, set_polylineOnZoom] = useState(false);
    const initZoom = window.innerHeight >= 1024 ? 8 : 7;
    const [zoom, _set_zoom] = useState(initZoom);
    const [FontScale, set_FontScale] = useState(window.innerHeight >= 1024 ? 2 : 1);

    const [taiwanSize, set_taiwanSize] = useState(null);
    const [viewBounds, set_viewBounds] = useState({
        east: 126.2425009765625,
        north: 31.89931697064517,
        south: 15.163355559149267,
        west: 115.8154990234375
    });
    //overlay
    const [overlayAlbumArr, set_overlayAlbumArr] = useState([]);

    const markerClustererRef = useRef(null);
    const markerRef = useRef(null);
    const mapPolyLineRef = useRef(null);
    const albumPolyLineRef = useRef(null);
    const mapStyleId = useRef(0);
    const displayPolylineZoom = 9;
    const onLoad = useCallback(function callback(map) {
        setMap(map);
        pageRef.current.querySelector("div").querySelector("div").style.backgroundColor = "#311f5b";
    }, []);

    const onUnmount = useCallback(function callback(map) {
        setMap(null);
    }, []);
    useEffect(() => {
        if (userData) {
            if (type === "user")
                updateRewild(achievementFriend?achievementFriend.user_id:"");
            else {
                updateFriendRewild(friendVo.user_id);
            }
        }
    }, []);

    function updateFriendRewild(uid) {
        apiManager.fetchGet(`user/${uid}/achievement`, {}, 0).then(res => {
            const __rewilds = res.map(rewild => {
                const rewildingObj = rewilding.find(v => v.rewilding_id === rewild.achievement_released_id);
                if (rewildingObj)
                    rewild.rewildingObj = rewildingObj;
                return rewild;
            });
            console.log("__rewilds", __rewilds)
            set_myRewild(__rewilds.sort((a, b) => 
                new Date(a.achievement_released_star_unlocked_at) - new Date(b.achievement_released_star_unlocked_at)
              ));
        });
    }
    function updateRewild(uid) {
        apiManager.fetchGet("achievement", { user_id: uid }, 0).then(res => {
            const __rewilds = res.map(rewild => {
                const rewildingObj = rewilding.find(v => v.rewilding_id === rewild.achievement_released_id);
                if (rewildingObj)
                    rewild.rewildingObj = rewildingObj;
                return rewild;
            });
            set_myRewild(__rewilds.sort((a, b) => 
                new Date(a.achievement_released_star_unlocked_at) - new Date(b.achievement_released_star_unlocked_at)
              ));
              
        });
    }
    useEffect(() => {
        if (map && screenArg) {
            if (screenArg.type === "notice")
                markerClick({ type: 'user', record: false, name: '大湖草原', lat: 24.4442, lng: 121.3063 }, screenArg.defaultOpenAlbumId);
        }
    }, [map]);
    useEffect(() => {
        if (map && groupSelectId === null && polylineEnable && polylineOnZoom && mapPolyLineRef.current === null) {
            mapPolyLineRef.current = new window.google.maps.Polyline({
                path: myRewild,
                geodesic: true,
                strokeColor: '#e0e730',
                strokeOpacity: .3,
                strokeWeight: 2
            });
            mapPolyLineRef.current.setMap(map);
        }
        else {
            if (mapPolyLineRef.current) {
                {
                    mapPolyLineRef.current.setMap(null);
                    mapPolyLineRef.current = null;
                }
            }
        }
    }, [polylineEnable, polylineOnZoom, groupSelectId]);

    const set_zoom = (zoom) => {
        _set_zoom(prev_zoom => {
            if (prev_zoom < displayPolylineZoom && zoom >= displayPolylineZoom) {
                set_polylineOnZoom(true);
            }
            else if (prev_zoom >= displayPolylineZoom && zoom < displayPolylineZoom) {
                set_polylineOnZoom(false);
            }
            return zoom;
        })
    }
    useEffect(() => {
        if (!map) return;
        setTimeout(() => {
            updateMapMarker();
        }, 100);
        const listener = map.addListener('zoom_changed', () => {
            set_zoom(map.getZoom());
            if (map.getZoom() > 8) {
                if (mapStyleId.current != 1) {
                    mapStyleId.current = 1;
                    setMapStyles(AppConfig.normalMapStyles);
                }
            }
            else {
                if (mapStyleId.current != 0) {
                    mapStyleId.current = 0;
                    setMapStyles(AppConfig.initialMapStyles);
                }
            }
        });

        function getMapBounds() {
            const bounds = map.getBounds();
            if (bounds) {
                const ne = bounds.getNorthEast(); // 右上角座標
                const sw = bounds.getSouthWest(); // 左下角座標
                const dy = ne.lat() - sw.lat(); // 緯度差距
                const dx = ne.lng() - sw.lng(); // 經度差距//1 度緯度大約等於 111.32 公里
                const mapDiv = map.getDiv();
                const mapWidth = mapDiv.offsetWidth;
                const mapHeight = mapDiv.offsetHeight;
                const latPerPx = dy / mapHeight; // 每像素對應的緯度距離
                const lngPerPx = dx / mapWidth;  // 每像素對應的經度距離
                const taiwanBounds = {
                    north: 25.32,
                    south: 21.87,
                    west: 120.0401,
                    east: 122.0011
                };
                let _bounds = expandBounds({
                    north: bounds.getNorthEast().lat(),
                    south: bounds.getSouthWest().lat(),
                    west: bounds.getSouthWest().lng(),
                    east: bounds.getNorthEast().lng(),
                },5);
                set_viewBounds(prev => {
                    if (prev === null)
                        return _bounds;
                    else
                        return prev;
                });
                const taiwanHeight = taiwanBounds.north - taiwanBounds.south; // 台灣的實際高度（緯度差距）
                const taiwanWidth = taiwanBounds.east - taiwanBounds.west;   // 台灣的實際寬度（經度差距）
                const taiwanHeightPx = taiwanHeight / latPerPx; // 台灣在畫面上顯示的高度（像素）
                const taiwanWidthPx = taiwanWidth / lngPerPx;   // 台灣在畫面上顯示的寬度（像素）
                set_taiwanSize({ width: taiwanWidthPx, height: taiwanHeightPx })
            } else {
                console.log("地圖邊界尚未確定");
            }
        }

        // 监听地图边界变化
        const listener2 = map.addListener('bounds_changed', () => {
            getMapBounds();
        });

        return () => {
            window.google.maps.event.removeListener(listener2);
            window.google.maps.event.removeListener(listener);

        };
    }, [myRewild, map, groupSelectId, viewBounds, polylineEnable]);

    async function updateMapMarker() {
        if (markerClustererRef.current) {
            markerClustererRef.current.clearMarkers();
            markerClustererRef.current.setMap(null);
            markerClustererRef.current = null;
        }
        if (markerRef.current) {
            markerRef.current.forEach(marker => {
                marker.setMap(null);
                marker = null;
            });

        }
        let pointArr = [];
        const groupName = (groupSelectId === null) ? "" : groupList[groupSelectId].name;
        //星星上面要有編碼，這張是共用的bitmapdata
        const starBitmap = await convertImagePathToImageBitmap('./map/icon_user_empty.png');
        const starBitmap_end = await convertImagePathToImageBitmap('./map/icon_user_end.png');
        //Cluster的icon
        let ClusterIcon;
        if (groupSelectId === null) {
            console.log("rewilding", myRewild)
            pointArr = myRewild;
            ClusterIcon = "./map/clusterIcon_user.png";
            pointArr.forEach(point => {
                point.lat = point.achievement_released_lat;
                point.lng = point.achievement_released_lng;
                point.name = point.rewilding_name;
            })
        }
        else {
            pointArr = AppConfig.areaList.filter(v => v.type === groupName);
            ClusterIcon = `./map/clusterIcon_${groupName}.png`;
            pointArr.forEach(point => {
                point.lat = point.lat;
                point.lng = point.lng;
                point.name = point.name;
            })
        }
        const markers = [
            ...pointArr.map((rewild, k) => {
                const label = {
                    text: rewild.name, // 您的 Marker 标签文本
                    color: "white",
                    fontSize: "12px",
                };
                let iconUrl;
                let size=32;
                if (groupSelectId === null) {
                    if (polylineEnable) {
                        iconUrl = createImageWithLabel(starBitmap, 32, 32, (k + 1), 16, "yellow", 50, 50)
                    }
                    else {
                        if (k === pointArr.length - 1)
                        {
                            iconUrl = './assets/ui/WhiteStar.png';
                            size=64;
                        }
                        else
                            iconUrl = createImageWithLabel(starBitmap, 32, 32, (k + 1), -1, "yellow", 50, 50)
                    }
                    //星星右上畫上數字

                }
                else {
                    iconUrl = `./map/icon_${groupName}${rewild.record === false ? "_empty" : ""}.png`;
                }
                const marker = new window.google.maps.Marker({
                    position: { lng: rewild.lng, lat: rewild.lat },
                    label: (map.getZoom() >= 10) ? label : null,
                    icon: {
                        url: iconUrl,
                        scaledSize: new window.google.maps.Size(size * FontScale, size * FontScale), // 调整图标的大小
                        anchor: new window.google.maps.Point(size/2 * FontScale, size/2 * FontScale),
                        labelOrigin: new window.google.maps.Point(size/2 * FontScale, size * FontScale)
                    }
                })
                if (groupSelectId === null)
                    marker.addListener('click', () => { markerClick(rewild) });
                return marker;
            }
            )
        ];
        markerRef.current = markers;
        markerClustererRef.current = new MarkerClusterer({
            markers,
            map,
            renderer: {
                render({ count, markers: clusterMarkers, position }) {
                    // 获取 markers 列表的最后一个值
                    const lastMarker = markers[markers.length - 1];

                    // 判断 clusterMarkers 是否包含最后一个 marker
                    const isLastMarkerInCluster = clusterMarkers.some(marker => marker === lastMarker);
                    const size=isLastMarkerInCluster?60:24;
                    return new window.google.maps.Marker({
                        position,
                        label: {
                            text: String(count),
                            color: "black",
                            fontSize: `${12 * FontScale}px`
                        },
                        icon: {
                            // 根据是否包含最后一个 marker 设置图标
                            url: (groupSelectId !== null) ? ClusterIcon : isLastMarkerInCluster ? './assets/ui/WhiteStar.png' : ClusterIcon,
                            scaledSize: new window.google.maps.Size(size * FontScale, size * FontScale),
                            anchor: new window.google.maps.Point(size/2 * FontScale, size/2 * FontScale),
                        }
                    });
                }
            },
            onClusterClick: (event, cluster) => {
                stepZoom(cluster, map);
            }
        });
    }

    function markerClick(rewild, defaultOpenAlbumId) {
        console.log("rewild", rewild)
        //if (rewild.type !== "user") return;
        setModalType(prev => prev.filter(v => v.cls !== "ShareLog"))
        setTimeout(() => {
            addModalType({
                cls: "ShareLog", arg: {
                    rewild: [rewild],
                    bar: true,
                    closeBtn: true,
                    blocking: false,
                    dismiss: true,
                    name: rewild.achievement_released_name,
                    defaultOpenAlbumId: defaultOpenAlbumId,
                    closeCb: () => {
                        set_overlayAlbumArr([]);
                        if (albumPolyLineRef.current) {
                            albumPolyLineRef.current.setMap(null);
                            albumPolyLineRef.current = null;
                            map.panTo(AppConfig.mapCenter);
                        }
                        set_zoom(initZoom);
                    },
                    viewAlbumOnMap: (event) => {
                        viewAlbumOnMap(event, rewild);
                    }
                }
            })
        }, 500);
    }
    const options = {
        restriction: {
            latLngBounds: viewBounds,
            strictBounds: true,
        },
        mapTypeControl: false,
        minZoom: 6, // 设置最大缩放级别
        maxZoom: 17,
        disableDefaultUI: true, // 禁用所有默认的UI控件
        zoomControl: false, // 禁用缩放控件（如果disableDefaultUI不够）
        mapTypeControl: false, // 禁用地图类型控件（如果disableDefaultUI不够）
        scaleControl: false, // 禁用比例尺控件（如果disableDefaultUI不够）
        streetViewControl: false, // 禁用街景控件（如果disableDefaultUI不够）
        rotateControl: false, // 禁用旋转控件（如果disableDefaultUI不够）
        fullscreenControl: false, // 禁用全屏控件（如果disableDefaultUI不够）
        styles: mapStyles,
        clickableIcons: false,
    };
    function viewAlbumOnMap(event) {
        console.log("event", event);
        apiManager.fetchGet(`collaborative-log/${event.events_id}/polaroids`).then(__polaroids => {
            console.log("polaroids", __polaroids);
            const display_polaroids = [];
            __polaroids.forEach(polaroid => {
                if (!(polaroid.event_polaroids_lat === 0 && polaroid.event_polaroids_lng === 0)) {
                    display_polaroids.push(polaroid);
                }
                else {
                    polaroid.event_polaroids_lat = event.events_lat;
                    polaroid.event_polaroids_lng = event.events_lng;
                    display_polaroids.push(polaroid);
                }
            });
            console.log("display_polaroids", display_polaroids);
            
            const uniqueCount = new Set(display_polaroids.map(item => `${item.event_polaroids_lat},${item.event_polaroids_lng}`)).size;
            set_overlayAlbumArr(display_polaroids);
            const bounds = new window.google.maps.LatLngBounds();
            display_polaroids.forEach(polaroid => {
                bounds.extend({ lat: polaroid.event_polaroids_lat, lng: polaroid.event_polaroids_lng });
            });
            // 計算新的南邊界 lat 高度  lng 寬度 左上到右下 p1 p2 p3 p4
            let y1 = bounds.getSouthWest().lat();
            let y2 = bounds.getNorthEast().lat();
            let x1 = bounds.getSouthWest().lng();
            let x2 = bounds.getNorthEast().lng();
            // 處理單一點情況
            if (uniqueCount === 1) {
                const singlePoint = display_polaroids[0];
                const buffer = 0.01; // 約等於 1 公里
                y1 = singlePoint.event_polaroids_lat - buffer * 2;
                y2 = singlePoint.event_polaroids_lat;
                x1 = singlePoint.event_polaroids_lng - buffer;
                x2 = singlePoint.event_polaroids_lng + buffer;
            }
            const dy = y2 - y1;
            let dx = x2 - x1;
            if (dy > dx) {
                const viewH = pageRef.current.clientHeight * .4;
                const pageW = pageRef.current.clientWidth;
                const viewP = pageW / viewH;
                const cx = (x1 + x2) / 2;
                x1 = cx - ((dy * viewP) / 2);
                x2 = cx + ((dy * viewP) / 2);
            }
            dx = x2 - x1;
            const pageH = pageRef.current.clientHeight;
            const pageW = pageRef.current.clientWidth;

            const R_screen = pageW / pageH;
            const R_div = dx / dy;

            // 假设画面的宽度W = 100
            const W = 100; // 100%

            // 计算画面的高度
            const H = W / R_screen;
            // 计算div的高度
            const H_div = W / R_div;
            // 计算偏移量
            const offset = (H - H_div) / 2;

            // 计算偏移百分比
            const offsetPercent = (offset / H_div);
            const offsetY = dy * (offsetPercent);
            y1 -= offsetY;
            y2 -= offsetY;
            // 創建新的 bounds
            const newBounds = new window.google.maps.LatLngBounds(
                new window.google.maps.LatLng(y1, x1),
                new window.google.maps.LatLng(y2, x2),
            );
            // 使用新的 bounds
            map.fitBounds(newBounds);
            if (albumPolyLineRef.current) {
                {
                    albumPolyLineRef.current.setMap(null);
                    albumPolyLineRef.current = null;
                }
            }

            albumPolyLineRef.current = new window.google.maps.Polyline({
                path: display_polaroids.map(polaroid => { return { lat: polaroid.event_polaroids_lat, lng: polaroid.event_polaroids_lng } }),
                geodesic: true,
                strokeColor: '#FFFFFF',
                strokeOpacity: 1,
                strokeWeight: 4
            });
            albumPolyLineRef.current.setMap(map);
        }).catch(err => {
            console.log(err);
        })

    }
    const handleScreenshot = async () => {
        const canvas = await html2canvas(pageRef.current, {
            useCORS: true,
        });

        const context = canvas.getContext('2d');
        const imageData = fixWhiteLine(context, canvas);

        // 将修改后的图像数据放回 canvas
        context.putImageData(imageData, 0, 0);

        const dataUrl = canvas.toDataURL('image/jpeg', 1);
        const blob = await dataUrlToBlob(dataUrl);
        const imageBlobUrl = URL.createObjectURL(blob);

        addModalType({
            cls: "Capture",
            arg: {
                dataUrl: imageBlobUrl,
                blob: blob
            }
        });
    };

    const dataUrlToBlob = async (dataUrl) => {
        const res = await fetch(dataUrl);
        return await res.blob();
    };

    return <div className={style.app}>
        <div className={style.view} ref={pageRef}>
            <GoogleMap
                shouldUnregisterMapOnUnmount={true}
                mapContainerStyle={AppConfig.containerStyle}
                center={AppConfig.mapCenter}
                zoom={zoom}
                onLoad={onLoad}
                onUnmount={onUnmount}
                options={options}
            >
                {(taiwanSize) &&
                    <OverlaySky taiwanSize={taiwanSize} position={AppConfig.mapCenter} map={map} />
                }
                {overlayAlbumArr.map(polaroid => {
                    return <OverlayAlbum key={v4()} overlayAlbumArr={overlayAlbumArr} polaroid={polaroid} map={map} addModalType={addModalType} />
                })}
            </GoogleMap>
            <BottomUi isStop={zoom >= 9} />
        </div>
        {overlayAlbumArr.length > 0 ?
            <div className={style.headTool2}>
                {/* <div className={style.label} onClick={e => {
                    addModalType({ cls: "CollectMemories", arg: { overlayAlbumArr: overlayAlbumArr } })
                }}>
                    <YStyled.Span size={15} color="#fff" style={{ textAlign: "center" }}>製作拍貼</YStyled.Span>
                    <img src="./assets/ui/shing.png" />
                </div> */}
            </div>
            :
            <div className={style.headTool}>
                {type === "friend" ?
                    <>
                        <div className={style.backDiv} onClick={e => {
                            onExitCb();
                        }}>
                            <img src="./assets/ui/arrowLeftSymbol.svg" />
                        </div>
                        <div className={style.groupList}>
                            <TabList selectId={groupSelectId} set_selectId={set_groupSelectId} list={groupList} ItemCls={AreaItem} clear={true} />
                        </div>
                    </>
                    :
                    <>
                        <div className={style.groupList}>
                            <TabList selectId={groupSelectId} set_selectId={set_groupSelectId} list={groupList} ItemCls={AreaItem} clear={true} />
                        </div>
                        <div className={style.splitLine}>
                            <div></div>
                        </div>
                        <div className={`${style.memoirs} ${achievementFriend?style.selected:""}`} >
                            <img src={achievementFriend?"./assets/ui/albumBlack.png":"./assets/ui/album.png"} onClick={e => {
                                if (userData)
                                    if(achievementFriend===null)
                                    {
                                        addModalType({
                                            cls: "Collaborative", arg: {
                                                cb: targetFriend => {
                                                    console.log("targetFriend", targetFriend);
                                                    set_achievementFriend(targetFriend);
                                                    if (targetFriend)
                                                        updateRewild(targetFriend.user_id);
                                                }
                                            }
                                        })
                                    }
                                    else {
                                        set_achievementFriend(null);
                                        updateRewild("");
                                    }
                                else
                                    window.location.href = AppConfig.registerUrl();
                            }} />
                        </div>
                    </>

                }

            </div>
        }

        {(userData && map?.getZoom() <= 8 && type === "user") &&
            <div className={style.rewildMsg}>
                <YStyled.Span size={12} fontFamily="SF Pro" color="#fff" style={{ textAlign: "center" }}>您的揪團已成功</YStyled.Span>
                <YStyled.Span size={12} fontFamily="SF Pro" color="#fff" style={{ textAlign: "center" }}>野放32人</YStyled.Span>
                <div className={style.arrowDown} />
            </div>
        }
        {map?.getZoom() <= 8 &&
            <div className={style.changeArea}>
                <YStyled.BTN_CIRCLE_1 w="6rem" h="3rem" onClick={e => {
                    if (userData)
                        addModalType({
                            cls: "OtherArea", arg: { myRewild: myRewild }
                        })
                    else
                        window.location.href = AppConfig.registerUrl();
                }}><YStyled.Span size={13} fontFamily="SF Pro" color="#fff">切換地區</YStyled.Span></YStyled.BTN_CIRCLE_1>
            </div>
        }
        {type === "user" &&
            <div className={style.addStar}>
                <YStyled.BTN_CIRCLE_1 w="4rem" h="4rem" onClick={e => {
                    if (userData) {
                        addModalType({
                            cls: "PhotoPreview", arg: {}
                        })
                    }
                    else {
                        window.location.href = AppConfig.registerUrl();
                    }
                }}><img src="./assets/ui/AddStar.png" /><img src="./assets/ui/add_w.png" /></YStyled.BTN_CIRCLE_1>
            </div>
        }

        <div className={style.rightTool} >
            {(zoom >= displayPolylineZoom && userData) &&
                <YStyled.BTN_CIRCLE_1 w="3rem" h="3rem" active={polylineEnable} onClick={e => {
                    set_polylineEnable(p => !p)
                }}><img src="./assets/ui/route.png" /></YStyled.BTN_CIRCLE_1>
            }
            <YStyled.Col align="center">
                <YStyled.BTN_CIRCLE_1 w="3rem" h="3rem" borderRadiusStyle="top" onClick={e => {
                    set_zoom(map.getZoom() + 1);
                }}><img src="./assets/ui/add_w.png" /></YStyled.BTN_CIRCLE_1>
                <YStyled.Row align="center" style={{ width: "3rem", background: "#7676803D" }}>
                    <YStyled.Hr width="80%" color="#EBEBF599"></YStyled.Hr>
                </YStyled.Row>
                <YStyled.BTN_CIRCLE_1 w="3rem" h="3rem" borderRadiusStyle="bottom" onClick={e => {
                    /* if (map.getZoom() > 7) */
                    set_zoom(map.getZoom() - 1);
                }}><img src="./assets/ui/sub_w.png" /></YStyled.BTN_CIRCLE_1>
            </YStyled.Col>
            {/* <YStyled.BTN_CIRCLE_1 w="3rem" style={{ opacity: (zoom === initZoom) ? 1 : 0 }} h="3rem" onClick={e => {
                if (zoom === initZoom) {
                    if (userData)
                        handleScreenshot()
                    else
                        window.location.href = AppConfig.registerUrl();
                }
            }}><img src="./assets/ui/capture.png" /></YStyled.BTN_CIRCLE_1> */}
        </div>


    </div>;
}

export default Tab2Content;
